'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _translate = require('../../language/translate');

/**
 * Validates the values in the Complete Application portion of the form (the second page).
 * * @param isGuardianNotRequired - Does the user require a legal guardian.
 * @param {Object} values - The values in the form to validate.
 * @returns {Object} Object of errors found in the form.
 */
exports.default = function (values, props) {
  var allApplicants = props.form.applicants ? props.form.applicants.concat(props.form.applicant) : [props.form.applicant];
  return {
    application: {
      additional_data: {
        province_of_residence: !values.application.additional_data.province_of_residence && (0, _translate.t)('Province of Residence is required')
      }
    },
    applicant: values.applicant.map(function (applicant, i) {
      var x = i + 1;
      return {
        first_name: !applicant.first_name && (0, _translate.t)('Applicant %(index)d: First Name is Required', { index: x }),
        last_name: !applicant.last_name && (0, _translate.t)('Applicant %(index)d: Last Name is Required', { index: x }),
        sex: !applicant.sex && (0, _translate.t)('Applicant %(index)d: Gender is Required', { index: x }),
        email: i === 0 && !applicant.email && (0, _translate.t)('Email address is Required'),
        address_line_1: i === 0 && !applicant.address_line_1 && (0, _translate.t)('Address Line 1 is Required'),
        city: i === 0 && !applicant.city && (0, _translate.t)('City is Required'),
        postal_code: i === 0 && !applicant.postal_code && (0, _translate.t)('Postal Code is Required'),
        phone: i === 0 && !applicant.phone && (0, _translate.t)('Phone Number is Required'),
        state: i === 0 && !applicant.state && (0, _translate.t)('Province/State is Required')
      };
    }),
    payment: {
      cardholder_name: !values.payment.cardholder_name && (0, _translate.t)('Cardholder Name is required')
    },
    terms: !values.terms && (0, _translate.t)('You must accept the terms and conditions')
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/association/Applicants.js
// module id = 1767
// module chunks = 0